import { useEffect } from 'react';

/**
 * Сигнал «цифры на сервере изменились».
 *
 * Бейджи таббара перечитываются по смене вкладки, хаб — при монтировании, но
 * прочтение ленты решений и разбор заявки меняют цифру, не уводя с вкладки.
 * Модулем, а не контекстом, как и `leaveGuard`: значения здесь нет, только
 * событие, и перерисовывать ради него дерево незачем.
 */
const listeners = new Set<() => void>();

/** Звать ПОСЛЕ ответа сервера: перечитанное раньше принесёт прежнее число. */
export function countersChanged(): void {
  for (const listener of listeners) listener();
}

/** Перечитывать своё по сигналу, пока компонент смонтирован. */
export function useCountersChanged(reload: () => void): void {
  useEffect(() => {
    listeners.add(reload);
    return () => {
      listeners.delete(reload);
    };
  }, [reload]);
}
